import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 50 36"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#fff",
  "stroke-width": "6",
  d: "M0 33h49.091M0 18h49.091M0 3h49.091"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }